export default __webpack_public_path__ + "static/media/typicons.d45316f6.ttf";